import { PropertyValueModel } from "../models/PropertyValueModel";

export const getValueFromProperty = (dto: { properties: Record<string, PropertyValueModel[]> }, propertyName: string): string => {
    if (dto.properties[propertyName]?.length) {
        return dto.properties[propertyName][0].value?.trim();
    }
    return "";
};
